import React from 'react';
import AppRouter from 'routing/route.main';
import { useGetCurrentClientAccountQuery  } from 'actions/client/client-account-api';
import { useGetTranslationsQuery  } from 'actions/translation-api';

const App = () => {
  useGetCurrentClientAccountQuery(); // login and get client account data
  useGetTranslationsQuery();

  return (
    <AppRouter />
  )
}

export default App;
